import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculateAge',
})
export class CalculateAgePipe implements PipeTransform {
  transform(value: Date, ...args: unknown[]): unknown {
    return this.calculateAge(value);
  }

  calculateAge(dobDate: Date): string {
    const today = new Date();
    let dob = new Date(dobDate);

    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();
    let days = today.getDate() - dob.getDate();

    // Adjust if day is negative
    if (days < 0) {
      months--;
      // Get number of days in previous month
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }

    if (
      years === 0 &&
      months === 0 &&
      days === 0 &&
      dob.toDateString() === today.toDateString()
    ) {
      return 'Newly born';
    }

    // Adjust if month is negative
    if (months < 0) {
      years--;
      months += 12;
    }

    let result = '';
    if (years > 0) result += `${years}y`;
    if (months > 0) result += ` ${months}m`;
    if (days > 0 || (!years && !months)) result += ` ${days}d`;

    return result.trim();
  }
}
